var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRuleCheckPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 434.4 198.1",
    style: {
      enableBackground: "new 0 0 434.4 198.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#DDDDDD;}\n\t.st1{fill:#CBCED2;}\n\t.st2{font-family:'Gotham-Bold';}\n\t.st3{font-size:21px;}\n\t.st4{fill:#DCDFE2;}\n\t.st5{fill:#EDEFF0;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_486",
    transform: "translate(-923.5 -528.237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    transform: "translate(-3151 3862.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    className: "st0",
    d: "M4173-3137.2l267.8-42.2"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 4163.9409 -3228.4761)",
    className: "st1 st2 st3"
  }, "%"), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    transform: "translate(4074.5 -3334.252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pass",
    className: "st1",
    d: "M88.5,196.6c-46.5-4.7-83.2-41.5-88-88c-0.7-6.7-0.7-13.5,0-20.2c0.9-9.2,3.2-18.2,6.6-26.8 l46.6,19.7c-1,2.6-1.9,5.4-2.4,8.1c-1.3,6.4-1.3,13.1,0,19.5c1.3,6.2,3.7,12.1,7.3,17.3c5.3,7.8,12.7,13.9,21.3,17.5 c2.9,1.2,6,2.2,9.1,2.8c6.4,1.3,13.1,1.3,19.5,0c6.2-1.3,12.1-3.7,17.3-7.3c7.8-5.3,13.9-12.7,17.5-21.3c1.2-2.9,2.2-6,2.8-9.1 c1.3-6.4,1.3-13.1,0-19.5c-1.3-6.2-3.7-12.1-7.3-17.3c-5.3-7.8-12.7-13.9-21.3-17.5c-2.9-1.2-6-2.2-9.1-2.8c-3.2-0.7-6.5-1-9.8-1 h-0.1V0l0,0c3.4,0,6.7,0.2,10.1,0.5c46.5,4.7,83.2,41.5,88,88c0.7,6.7,0.7,13.5,0,20.2c-4.7,46.5-41.5,83.2-88,88 C101.9,197.3,95.2,197.3,88.5,196.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Review",
    className: "st4",
    d: "M7.2,61.8c0.2-0.4,0.4-0.9,0.5-1.3C19.6,32.4,43.8,11.4,73.2,3.6L86,52.8 c-5.2,1.4-10.1,3.6-14.5,6.6C63.7,64.6,57.6,72,53.9,80.7c-0.1,0.3-0.2,0.6-0.4,0.9L7.2,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fail",
    className: "st5",
    d: "M73.1,3.7c1.9-0.5,3.8-1,5.8-1.4c3.2-0.7,6.5-1.2,9.8-1.5c3.3-0.3,6.7-0.5,10.1-0.5l0,0v50.8 c-3.2,0-6.4,0.3-9.6,1c-1,0.2-2,0.4-3,0.7L73.1,3.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 4432.1074 -3238.2847)",
    className: "st1 st2 st3"
  }, "%")), /*#__PURE__*/React.createElement("g", {
    id: "Group_40-2",
    transform: "translate(4372.725 -3313.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pass-2",
    className: "st1",
    d: "M61.1,136C29,132.8,3.6,107.4,0.4,75.2c-0.5-4.6-0.5-9.3,0-13.9C1,54.9,2.5,48.7,4.9,42.8 l32.2,13.6c-0.7,1.8-1.3,3.7-1.7,5.6c-0.9,4.4-0.9,9,0,13.5c0.9,4.3,2.6,8.3,5,12c3.6,5.4,8.7,9.6,14.7,12.1 c2,0.9,4.1,1.5,6.3,1.9c4.4,0.9,9,0.9,13.5,0c4.3-0.9,8.3-2.6,12-5c5.4-3.6,9.6-8.7,12.1-14.7c0.9-2,1.5-4.1,1.9-6.3 c0.9-4.4,0.9-9,0-13.5c-0.9-4.3-2.6-8.3-5-12c-3.6-5.4-8.7-9.6-14.7-12.1c-2-0.9-4.1-1.5-6.3-1.9c-2.2-0.5-4.5-0.7-6.7-0.7h-0.1 V0.2l0,0c2.3,0,4.7,0.1,7,0.4c32.1,3.3,57.5,28.7,60.8,60.8c0.5,4.6,0.5,9.3,0,13.9c-3.3,32.1-28.7,57.5-60.8,60.8 C70.4,136.5,65.8,136.5,61.1,136z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Review-2",
    className: "st4",
    d: "M4.8,42.5c0.1-0.3,0.2-0.6,0.4-0.9c8.2-19.5,25-34,45.4-39.4l8.8,34.1c-3.6,1-7,2.5-10.1,4.6 c-5.4,3.6-9.6,8.8-12.1,14.7c-0.1,0.2-0.2,0.4-0.2,0.6L4.8,42.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fail-2",
    className: "st5",
    d: "M50.4,2.3c1.3-0.4,2.6-0.7,4-0.9c2.2-0.5,4.5-0.8,6.8-1c2.3-0.2,4.6-0.4,7-0.4l0,0v35.2 c-2.2,0-4.5,0.2-6.7,0.7c-0.7,0.1-1.4,0.3-2.1,0.5L50.4,2.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    className: "st0",
    d: "M4173-3334.3l267.8,20.5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuleCheckPlaceholder);
export default __webpack_public_path__ + "static/media/rule-check-placeholder.90a352f78d912008c73d19fcbe87d255.svg";
export { ForwardRef as ReactComponent };